import { isAfter } from "date-fns"
import { IsValidCheck } from "./types"

export const isOffCoverAfterOnCoverError = `Off cover date must be after on cover date`
export const isOffCoverAfterOnCover: IsValidCheck = (entry) => {
  if (!entry.onCoverDate || !entry.offCoverDate) return undefined

  const onCoverDate = new Date(entry.onCoverDate)
  const offCoverDate = new Date(entry.offCoverDate)

  return !isAfter(onCoverDate, offCoverDate)
}
